import { render, staticRenderFns } from "./FloatingPoint.vue?vue&type=template&id=345530ea&scoped=true&"
import script from "./FloatingPoint.vue?vue&type=script&lang=js&"
export * from "./FloatingPoint.vue?vue&type=script&lang=js&"
import style0 from "./FloatingPoint.vue?vue&type=style&index=0&id=345530ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345530ea",
  null
  
)

export default component.exports